$(document).ready(function () {
  var scroll = new SmoothScroll('a[href*="#"]');
});

$(document).ready(function () {
  var mySwiper = new Swiper ('.hero', {
	  effect: "fade",
	  speed: 5000,
    autoplay: {
	    delay: 5000,
    },
	  fadeEffect: {
	    crossFade: true
	  },
	  noSwiping: true,
	  simulateTouch: false,
	  visibilityFullFit: true,
  })
});

$(document).ready(function () {
  var swiper = new Swiper('#design-list', {
	  speed: 3000,
    slidesPerView: 4,
    spaceBetween: 10,
    loop: true,
    freeMode: true,
    freeModeMomentum:true,
    autoplay: {
      delay: 0,
    },
    autoplayDisableOnInteraction: false,
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      }
    }
  });
});

// welcomeセクション フルスクリーン
$(document).ready(function () {
  hsize = $(window).height();
  $("#welcome").css("height", hsize + "px");
});
$(window).resize(function () {
  hsize = $(window).height();
  $("#welcome").css("height", hsize + "px");
});

// header toggle
$(function() {
  var $header = $('.shopify-section > header');
  $(window).scroll(function() {
    if ($(window).scrollTop() > 350) {
      $header.addClass('fixed');
    } else {
      $header.removeClass('fixed');
    }
  });
  // Nav Toggle Button
  $('#nav-toggle').click(function(){
    $header.toggleClass('open');
  });
  $('header ul a').click(function(){
    $header.toggleClass('open');
  });
});

// to top button 
$(function(){
	var $toTop = $('.totop');
	$(window).scroll(function() {
		if ($(window).scrollTop() > 600) {
			$toTop.fadeIn(500);
		} else {
			$toTop.fadeOut(500);
		}
	});
});

// element fade-in
$(function(){
    $(window).scroll(function (){
        $('.main-photo,.photos').each(function(){
            var elemPos = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > elemPos - windowHeight + 200){
                $(this).addClass('fade-in');
            }
        });
    });
});